module.exports = function(app) {
	app
	.controller('appCtrl', appCtrl)
    .factory('$exceptionHandler', exceptionHandler);
	appCtrl.$inject=['getConfigData','eventStream','$http','API_URL','jwtDecoderService','$interval','getIspTitle','$timeout','$location','config', '$scope', '$localStorage','$state','$stateParams','authtokenService','$rootScope','refreshtokenService','$element','alertService', 'getDataService','jQuery','navigationService','serverError','warningAlertService'];
	function appCtrl(getConfigData,eventStream,$http,API_URL,jwtDecoderService,$interval,getIspTitle,$timeout,$location, config, $scope, $localStorage,$state,$stateParams, authtokenService, $rootScope,refreshtokenService,$element,alertService, getDataService, jQuery, navigationService,serverError,warningAlertService) {
		var vma = this;
		vma.sidebarshow = false;
		vma.title = config.appTitle;
	    $scope.app = config;
		vma.config = config;
	    $scope.$state = $state;
	    $rootScope.ngEscapeAttrsParametars = [];
		// vma.notifications = [];
	    $rootScope.hasLoaded = true;
	    $rootScope.serverError={
	    	'show' : false
	    }
		$rootScope.offlineError = false;
		// vma.focusLocked = {
		// 	locked: false,
		// 	name: '',
		// 	userId: ''
		// }
		
		// vma.socketData = undefined;
		// vma.notificationNews= socketNews.notificationNews;
		vma.refreshTokenInterval = config.refreshTokenInterval;
		// function displayNotification(obj) {
		// 	if(vma.notifications.length>=5) {
		// 		vma.notifications.splice(0,1)
		// 	}
		// 	vma.notifications.push(obj)
		// }
		// function appControllerNewSocketCb(data) {
		// 	if(data.type=='new') {
		// 		$scope.$apply(function () {
		// 			vma.notificationNews.new[data.service]  = vma.notificationNews.new[data.service] + data.count
		// 			vma.notificationNews.newTotalCount = vma.notificationNews.newTotalCount + data.count
		// 		})
		// 		for (var i = 0;i<data.posts.length;i++) {
		// 			if(data.posts[i].pm && data.posts[i].pm.display) {
		// 				$scope.$apply(function () {
		// 					displayNotification({
		// 						headerText: data.posts[i].headerText,
		// 						contentText: data.posts[i].title,
		// 						btnText: "Pogledaj",
		// 						btnFunc: "app."+data.service+"_allnews({id:'"+ data.posts[i]._id + "'})",
		// 						type:'danger',
		// 						id: data.posts[i]._id,
		// 						animation:data.posts[i].pm.animation
		// 					})
		// 				})
		// 			}
		// 		}
		// 	}
		// }
		// function appControllerAssignedSocketCb(data) {
		// 	if(data.type == 'add') {
		// 		//prevent duplicate obj in array
		// 		for (var i = 0; i<vma.notificationNews.assigned.length;i++) {
		// 			if(vma.notificationNews.assigned[i]._id == data.post._id) {
		// 				return
		// 			}
		// 		}
		// 		$scope.$apply(function () {
		// 			vma.notificationNews.assigned.unshift(data.post)
		// 			displayNotification({
		// 				headerText: data.message,
		// 				contentText: data.post.title,
		// 				btnText: "Preuzmi",
		// 				btnFunc: "app.allposts({id:"+ data.post._id + "})",
		// 				type:'primary',
		// 				id: data.post._id,
		// 				animation:data.animation
		// 			})
		// 		})
		// 	} else if(data.type=='delete') {
		// 		for (var i =0;i<vma.notificationNews.assigned.length;i++) {
		// 			if(vma.notificationNews.assigned[i]._id == data.post_id) {
		// 				$scope.$apply(function () {
		// 					vma.notificationNews.assigned.splice(i,1)
		// 				})
		// 				break
		// 			}
		// 		}
		// 		$scope.$apply(function () {	
		// 			vma.notificationsDeleteFunction(data.post_id)
		// 		})
		// 	}
		// }
		// socketNews.socketNewsListener.on('assignedNews', appControllerAssignedSocketCb)
		// socketNews.socketNewsListener.on('newNews', appControllerNewSocketCb)
		// if(window.socketAnalytics) {
		// 	window.socketAnalytics.on('global', function(wsData){
		// 		if(!wsData) return
		// 		$scope.$apply(function () {
		// 			vma.socketData = wsData
		// 			vma.socketData.ispArray = []
		// 			if(wsData.isp instanceof Object) {
		// 				for (var isp in wsData.isp) {
		// 					vma.socketData.ispArray.push({name:isp, count:wsData.isp[isp]});
		// 				}
		// 			} 
		// 		})
		// 	})
		// }
		// function focusTakeoverFunction(takeoverMessage) {
		// 	warningAlertService('Focus takeover',takeoverMessage,function cb() {
		// 		var url = API_URL+ "focus/takeover"
        //   		var updateDataPost = {}
		// 		var updateFunction = function() {
		// 			$http.put(url , updateDataPost)
		// 			.success(function (data, stat, headers) {
		// 			alertService('success','Success ', data.message, 2000);
		// 			$timeout(function() {
		// 				$state.go('app.allfocus');
		// 			},0)
		// 			})
		// 			.error(function (data, status, header, config) {
		// 			if(!window.navigator.onLine) {
		// 				offlineError()
		// 				alertService('danger','Opps! ', 'Please check your internet connection and try again.');
		// 				return
		// 			}
		// 			if(status ==401) {
		// 				var promise = refreshtokenService.getAccessToken();
		// 				promise.then(
		// 				function(answer) {
		// 					if(answer==200) {   
		// 					updateFunction();
		// 					}
		// 				},
		// 				function(error) {
		// 				},
		// 				function(progress) {
		// 				// report progress
		// 				});
		// 			}else if(status ==502) {
		// 				serverError()  
		// 			} else { 
		// 				alertService('danger','Opps! ', (data && data.error && data.error.message)? data.error.message:'Failed to load response data.');
		// 			}
		// 			}); 
		// 		}
		// 		updateFunction();
		// 	});
		// }
		// vma.focusTakeover = function() {
		// 	if(!vma.focusLocked.locked) {
		// 		$state.go('app.allfocus');
		// 		return
		// 	}
		// 	var takeoverMessage;
		// 	if(vma.focusLocked.userId == vma.userId) {
		// 		if($state.current.name === 'app.allfocus') return;
		// 		takeoverMessage = "Focus is currently being edited in another session. If you take over, any unsaved changes there will be lost. Do you want to continue?";
		// 	} else {
		// 		takeoverMessage = '<strong>' + vma.focusLocked.name + '</strong> is currently editing the Focus section. Do you want to take control?';
		// 	}
		// 	focusTakeoverFunction(takeoverMessage);
		// }
		// function heartbeatCallback(data) {
		// 	$scope.$apply(function() {
		// 		if(data.type=='focus_locked') {
		// 		  vma.focusLocked.locked = true;
		// 		  vma.focusLocked.name = data.locked_by_name;
		// 		  vma.focusLocked.userId = data.locked_by;
		// 		} else if(data.type=='focus_unlocked') {
		// 		  vma.focusLocked.locked = false;
		// 		  vma.focusLocked.name = '';
		// 		  vma.focusLocked.userId = '';
		// 		}
		// 	});
		// }
		// $scope.$watch(function() {
		// 	return vma.config
		// }, function(newValue, oldValue) {
		// 	if(newValue !== oldValue && !$state.is('login')) {
		// 		if(vma.config.lockingManager && vma.config.lockingManager['focus']) {
		// 			if(!eventStream.getConnection('focus')) {
		// 				eventStream.connect('focus',vma.config.lockingManager['focus']);
		// 			}
		// 			if(!eventStream.hasMessageHandler('focus',heartbeatCallback)) {
		// 				eventStream.onMessage('focus',heartbeatCallback);
		// 			}
		// 		}
		// 		if(vma.config.focus_lock && Object.keys(vma.config.focus_lock).length>0 && vma.config.focus_lock.type == 'focus_locked') {
		// 			vma.focusLocked.locked = true;
		// 			vma.focusLocked.name = vma.config.focus_lock.locked_by_name;
		// 			vma.focusLocked.userId = vma.config.focus_lock.locked_by;
		// 		} else {
		// 			vma.focusLocked.locked = false;
		// 			vma.focusLocked.name = '';
		// 			vma.focusLocked.userId = '';
		// 		}
		// 	}
		// },true);
		// vma.getIspTitle = getIspTitle;
		vma.currentstate = [];
        setTimeout(function() {
			window.loaded = 'loaded';
		},0);
	    vma.refreshTokenInterval = config.refreshTokenInterval;
		if (angular.isDefined($localStorage.state)){
		    $scope.app.state = $localStorage.state;
		} else {
		    $localStorage.state = $scope.app.state;
		}
		vma.getCredential = function() {
			vma.name = authtokenService.getName();
			vma.avatar = authtokenService.getAvatar();
			$rootScope.role_id = authtokenService.getRoleId();
		}
		$scope.$on('is-aunthenticated', function(evt,data){
			vma.isAuth = data.isAuth;
			vma.getCredential();
			
		});
		vma.getCredential();
		
		$rootScope.isLogout = false;
		function logOutSuccess() {
			$rootScope.isLogout = true;
			$state.go('login');
			$rootScope.alerts = [];
			$rootScope.alertShow = false;
			$timeout(function() {
				authtokenService.removeToken();
				alertService('success','Success ', 'You are now Log Out', 2000);
			}, 0);
		}
		vma.logout =function() {
			$rootScope.hasLoaded = false;
			function logOut() {
				$http.post(API_URL + 'auth/logout',{
					'user_id': authtokenService.getUserId()
				}).success(function(response) {
					$rootScope.hasLoaded = true;
					logOutSuccess();
				}).error(function(error) {
					if(error.status == 401) {
						var promise = refreshtokenService.getAccessToken();
				  		promise.then(
							function(answer) {
							if(answer==200) {
								logOut();
							}
							},
							function(error) {
							},
							function(progress) {
							// report progress
						});
					} else {
						logOutSuccess();
					}
					$rootScope.hasLoaded = true;
				});	
			}
			logOut();
			
		}
		var firstLoad = false;
		vma.changeMenuItem = function(state) {
			for (var i=0; i < $rootScope.navigation.length;i++) {
				if($rootScope.navigation[i].items) {
					for(var j=0; j < $rootScope.navigation[i].items.length; j++) {
						if($rootScope.navigation[i].items[j].state == state && !vma.currentstate.includes(i)) {
							vma.currentstate.push(i);
						}
					}
				}
			} 
		}
		var deregistrationFunction;
		$rootScope.$on('$stateChangeStart',
        function(event, toState, toParams, fromState, fromParams){
			// // Handle favicon and title changes for allfocus state
			// if(toState.name === 'app.allfocus') {
			// 	// Change favicon to favicon2.ico
			// 	var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
			// 	link.type = 'image/x-icon';
			// 	link.rel = 'shortcut icon';
			// 	link.href = '/favicon2.ico';
			// 	document.getElementsByTagName('head')[0].appendChild(link);
				
			// 	// Change page title
			// 	document.title = 'Focus - Telegraf CMS';
			// } else if(fromState.name === 'app.allfocus') {
			// 	// Revert favicon back to favicon.ico when leaving allfocus state
			// 	var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
			// 	link.type = 'image/x-icon';
			// 	link.rel = 'shortcut icon';
			// 	link.href = '/favicon.ico';
			// 	document.getElementsByTagName('head')[0].appendChild(link);
				
			// 	// Revert page title
			// 	document.title = 'Telegraf CMS';
			// }
			var stateCurrent = toState.name;
			var state = stateCurrent.substr(4);
				//reload to some state exept login             from login   
			if((!fromState.name && toState.name != 'login') || fromState.name === 'login') {
				// socketNews.getAssignedNewsApi()
				// if($scope.app.socketUrl) {
				// 	socketNews.connect()
				// }
				if(deregistrationFunction) {
					deregistrationFunction()
				}
				//active menu item
				deregistrationFunction = $scope.$watch(function(){
					return $rootScope.navigation
				  }, function(newValue, oldValue){
					if (newValue !== oldValue) {
						vma.changeMenuItem(state);
					}
				},true);
				vma.userId = parseInt(authtokenService.getUserId());
			}
			if(fromState.name === 'login' && $rootScope.isLogout) {
				vma.config.load = false;
				$rootScope.isLogout = false;
			}
            vma.sidebarshow=false;
            $element.removeClass('overflow-hidden');
            if(toState.name !== 'login') {
				if(!vma.getRefreshTokenInterval) {
					vma.getRefreshTokenInterval = $interval(function() {
						var refreshToken = authtokenService.getRefreshToken();
						if(!refreshToken) return
						var refreshTokenExpirationDate = jwtDecoderService.getExpirationDate(refreshToken);
						if(!refreshTokenExpirationDate) return
						var now = new Date();
						var timeUntilExpiration = refreshTokenExpirationDate.getTime() - now.getTime();
						var fiveMinutesInMs = 5 * 60 * 1000; // 5 minutes in milliseconds
						
						if(timeUntilExpiration <= fiveMinutesInMs) {
							$http.post(API_URL + 'auth/renewRefreshToken',{
								'user_id': authtokenService.getUserId()
							}).success(function(response) {
								authtokenService.setrefreshToken(response.refresh_token);
							}).error(function(error) {
								$rootScope.alerts = [];
								$rootScope.alertShow = false;
								authtokenService.removeToken();
								$state.go('login');
							});
						}
					}, vma.refreshTokenInterval*1000);
				}
	            if(!$rootScope.navigation && authtokenService.getToken()) {
			 		navigationService.getNavigation();
		       	}
				if(!firstLoad) {
					// $scope.$watch(function(){
					// 	return $scope.app.socketUrl
					//   }, function(newValue, oldValue){
					// 	if (newValue !== oldValue) {
					// 		socketNews.connect()
					// 	}
					// },true);
					firstLoad = true
				}
				if($rootScope.navigation) {
					vma.changeMenuItem(state);
				}
				// if(!eventStream.getConnection('focus') && vma.config.lockingManager && vma.config.lockingManager['focus'] && !$state.is('login')) {
				// 	eventStream.connect('focus',vma.config.lockingManager['focus']);
				// }
				// if(!eventStream.hasMessageHandler('focus',heartbeatCallback)) {
				// 	eventStream.onMessage('focus',heartbeatCallback);
				// }
            } else {
				// vma.focusLocked = {
				// 	locked: false,
				// 	name: '',
				// 	userId: ''
				// }
				// if(eventStream.getConnection('focus')) {
				// 	eventStream.disconnect('focus');
				// }
				// vma.notifications.length = 0;
				// socketNews.disconnect();
				if(vma.getRefreshTokenInterval) {
					$interval.cancel(vma.getRefreshTokenInterval)
					vma.getRefreshTokenInterval = null;
				}
			}

        });
		angular.element(document).on('touchstart', function(e) {
		  if(!vma.sidebarshow) return;
	      var container = angular.element(document.getElementById("sidebar"));
	      var hamburger = angular.element(document.getElementsByClassName('hamburger')[0]);
	      if (!container.is(e.target) // if the target of the click isn't the container...
	        && container.has(e.target).length === 0 && !hamburger.is(e.target) && hamburger.has(e.target).length === 0) // ... nor a descendant of the container
	      {
	        $scope.$apply(function () {
	          vma.sidebarshow = false;
	          $element.removeClass('overflow-hidden');
	        });
	      }
	    });
  		vma.toggleNav = function() {
  			vma.sidebarshow=!vma.sidebarshow;
  			$element.toggleClass('overflow-hidden');
  		}
  		vma.subCategoryOpen = function(index) {
			if(!vma.currentstate.includes(index)) {
				vma.currentstate.push(index);
			}else {
				var indexToRemove = vma.currentstate.indexOf(index);
				if (indexToRemove !== -1) {
					vma.currentstate.splice(indexToRemove, 1);
				}
			}{}
  		}
  		vma.currentStateHandler = function($event, state) {
			// if(state == 'allfocus' && vma.focusLocked.locked) {
			// 	var takeoverMessage;
			// 	if(vma.focusLocked.userId != vma.userId) {
			// 		takeoverMessage = '<strong>' + vma.focusLocked.name + '</strong> is currently editing the Focus section. Do you want to take control?';
			// 		focusTakeoverFunction(takeoverMessage);
			// 	} else {
			// 		if($state.current.name !== 'app.allfocus') {
			// 			takeoverMessage = "Focus is currently being edited in another session. If you take over, any unsaved changes there will be lost. Do you want to continue?";
			// 			focusTakeoverFunction(takeoverMessage);
			// 		}
			// 	}
			// 	$event.preventDefault();
			// 	return
			// }
  			var currentState = $event.target;
  			if($state.is('app.allposts')) {
  				if(jQuery(currentState).hasClass('allposts')) {
  					$timeout($rootScope.closeEditPost, 10);
  				}
  			}
			if($state.is('app.myposts')) {
				if(jQuery(currentState).hasClass('myposts')) {
					$timeout($rootScope.closeEditPost, 10);
				}
			}
  			if($state.is('app.allpages')) {
  				if(jQuery(currentState).hasClass('allpages')) {
  					$timeout($rootScope.closeEditPage, 10);
  				}
  			}
  			if($state.is('app.allpolls')) {
  				if(jQuery(currentState).hasClass('allpolls')) {
  					$timeout($rootScope.closeEditPoll, 10);
  				}
  			}
			if($state.is('app.allratings')) {
				if(jQuery(currentState).hasClass('allratings')) {
					$timeout($rootScope.closeEditRating, 10);
				}
			}
			// if($state.is('app.allliveblogs')) {
			// 	if(jQuery(currentState).hasClass('allliveblogs')) {
			// 		$timeout($rootScope.closeEditLiveblog, 10);
			// 	}
			// }
  			if($state.is('app.library')) {
  				if(jQuery(currentState).hasClass('library')) {
  					$timeout($rootScope.closeEditMedia, 10);
  				}
  			}
  			if($state.is('app.allusers')) {
  				if(jQuery(currentState).hasClass('allusers')) {
  					$timeout($rootScope.closeEditUser, 10);
  				}
  			}
  			if($state.is('app.tags')) {
  				if(jQuery(currentState).hasClass('tags')) {
  					$timeout($rootScope.closeEditTag, 10);
  				}
  			}
  			if($state.is('app.categories')) {
  				if(jQuery(currentState).hasClass('categories')) {
  					$timeout($rootScope.closeEditCategory, 10);
  				}
  			}
  			if($state.is('app.video_categories')) {
  				if(jQuery(currentState).hasClass('video_categories')) {
  					$timeout($rootScope.closeEditVideoCategory, 10);
  				}
  			}
  			if($state.is('app.video_tags')) {
  				if(jQuery(currentState).hasClass('video_tags')) {
  					$timeout($rootScope.closeEditVideoTag, 10);
  				}
  			}
  			if($state.is('app.allvideos')) {
  				if(jQuery(currentState).hasClass('allvideos')) {
  					$timeout($rootScope.closeEditVideo, 10);
  				}
  			}
			if($state.is('app.ai_all_configurations')) {
				if(jQuery(currentState).hasClass('ai_all_configurations')) {
					$timeout($rootScope.closeEditConfiguration, 10);
				}
			}
  		}
	}

	exceptionHandler.$inject = ['$log', '$window', '$injector'];
	function exceptionHandler($log, $window, $injector) {
	    return function (exception, cause) {
	      var errors = $window.JSON.parse($window.localStorage.getItem('sing-2-angular-errors')) || {};
	      errors[new Date().getTime()] = arguments;
	      $window.localStorage.setItem('sing-2-angular-errors', $window.JSON.stringify(errors));
	      if ($injector.get('config').debug) {
	        $log.error.apply($log, arguments);
	        $window.alert('check errors');
	      }
	    };
	}		
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/app/js/appController.js
// module id = 424
// module chunks = 0